module.exports = __webpack_public_path__ + "static/0012-0f6f7dd9ce9430a8fb9974ed2a756b39.png";